import { FormattedMessage } from 'react-intl';

import { PriceGroup } from '@ocx-app/modules/stores/types';
import { FuelPriceState } from '@ocx/graphql';
import { Typography } from '@ocx/ui';

import { PricesGrid, PricesGridProps } from './prices-grid.component';
import { BoxItemComponent } from './box-item.component';
import { messages } from '../../store-locator.messages';

type PricesGridControllerProps = Omit<
  PricesGridProps,
  'prices' | 'isExpanded' | 'shouldLimitRenderItems' | 'onRevealRestPricesClick'
> & {
  priceGroups: PriceGroup[];
  pricesGridDefaultTitle?: string;
  isExpandedByDefault?: boolean;
  fuelPriceState: FuelPriceState | null;
};

export const PricesGridController = ({
  priceGroups,
  pricesGridDefaultTitle,
  isExpandedByDefault,
  fuelPriceState,
}: PricesGridControllerProps) => {
  if (fuelPriceState === FuelPriceState.Expired) {
    return (
      <BoxItemComponent>
        <Typography variant="body2">
          <FormattedMessage {...messages['storeLocator:store:fuelPriceExpiredMessage']} />
        </Typography>
      </BoxItemComponent>
    );
  }

  return (
    <>
      {priceGroups.map((group, index) => {
        return (
          <PricesGrid
            key={group.title}
            title={priceGroups.length > 1 ? group.title : pricesGridDefaultTitle}
            prices={group.prices}
            isExpanded={isExpandedByDefault}
            marginTop={index > 0}
          />
        );
      })}
    </>
  );
};
